import axios from 'axios';

import addDefaultHeaders from '@/api/interceptors/add-default-headers';
import formatResponse from '@/api/interceptors/format-response';

const $http = axios.create();

$http.interceptors.request.use(addDefaultHeaders);

$http.interceptors.response.use(formatResponse);

export default $http;
